module.exports = __webpack_public_path__ + "static/media/office_6@2x.5bf3cbf1.jpg";